var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"previewBox"},[_c('el-table',{staticStyle:{"width":"100%"}},_vm._l((_vm.tableData),function(item){return _c('el-table-column',{key:item.key,attrs:{"label":item.label}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }